<template>
  <v-dialog
    :value="visible"
    persistent
    :fullscreen="!$vuetify.breakpoint.smAndUp"
  >
    <bm-card :label="$m.containers_error_dialog_title" class="bm-card-error">
      <template #menu><v-icon @click="cancel">highlight_off</v-icon></template>

      <bm-form ref="form">
        <v-container fluid>
          <div v-for="text in errorMessages" :key="text">
            {{ text }}
          </div>
        </v-container>
      </bm-form>

      <template #controls>
        <v-row class="ma-0">
          <v-col cols="12" lg="6" class="text-right">
            <bm-btn
              :block="!$vuetify.breakpoint.smAndUp"
              button-type="primary"
              @click="submit"
              >{{ $m.ok }}</bm-btn
            >
          </v-col>
        </v-row>
      </template>
    </bm-card>
  </v-dialog>
</template>

<script lang="ts">
import BmCard from "@/components/controls/card/BmCard.vue";
import type { PropType } from "vue";
import { defineComponent, ref } from "vue";
import { useReactiveDialogSetup } from "@/components/mixins/dialogs";

export default defineComponent({
  name: "BarcodeScannerErrorDialog",
  components: { BmCard },
  props: {
    errorMessages: {
      type: Array as PropType<string[]>,
      required: false,
    },
    visible: {
      type: Boolean,
      required: true,
    },
  },
  setup(props, context) {
    const { accept, cancel } = useReactiveDialogSetup(
      ref(props.visible),
      context
    );
    return {
      submit: () => {
        accept();
      },
      cancel,
    };
  },
});
</script>

<style scoped lang="sass">
@import "src/sass/colours"

:deep(.bm-card-error .bm-card-title), :deep(.bm-card-error .bm-card-title *)
  color: white
  background-color: $bm-color-error-medium
</style>
